'use client';

import { useAuthStore } from '@/app/store/use-auth-store';
import { Button } from '@/shared/ui/button';
import { CField } from '@/shared/ui/cfield';
import { Input, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useAuthFlowStore } from '../../model/use-auth-flow-store';
import { useRegisterWithoutOTP } from '../api/query';

type Props = {
  onSuccess: () => void;
};

const RegisterForm: React.FC<Props> = ({ onSuccess }) => {
  const t = useTranslations();
  const { payload } = useAuthFlowStore();
  const { setUser } = useAuthStore();
  const { mutate: registerWithoutOTP, isPending } = useRegisterWithoutOTP();

  const [errors, setErrors] = useState({ name: '' });

  const [formData, setFormData] = useState({
    name: payload.name,
    date_of_birth: payload.date_of_birth,
  });

  // handle input changes
  const onChange = (value: string, name: string) => {
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Register user
  const onRegister = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!formData.name) {
      setErrors({ name: t('this_field_required') });
      return;
    }

    const data = {
      phone: payload.phone,
      name: formData.name,
      date_of_birth: formData.date_of_birth || null,
      registration_source: 'website',
    };

    registerWithoutOTP(data, {
      onSuccess: (data) => {
        setUser(data);
        onSuccess();
      },
    });
  };

  return (
    <form onSubmit={onRegister}>
      <Text color={'text'} fontSize="2xl" fontWeight={700} mb={6}>
        {t('personal_data')}
      </Text>

      <Stack gap={4}>
        <CField label={t('your_name')} bgColor="background" color={'text'}>
          <Input
            placeholder=""
            className="peer"
            value={formData.name}
            onChange={(e) => onChange(e.target.value, 'name')}
            borderColor={errors.name ? 'red.500' : 'inherit'}
          />
          {errors.name && (
            <Text color="red.500" fontSize="sm">
              {errors.name}
            </Text>
          )}
        </CField>
        <CField label={t('birthday')} bgColor="background" color={'text'}>
          <Input
            type="date"
            bgColor="background"
            color={'text'}
            placeholder=""
            className="peer"
            value={formData.date_of_birth || ''}
            onChange={(e) => onChange(e.target.value, 'date_of_birth')}
          />
        </CField>
      </Stack>

      <Button
        type="submit"
        size="xl"
        mt={4}
        w="full"
        height="56px"
        fontWeight={600}
        fontSize="md"
        bg="primary"
        color="primary.text"
        _hover={{
          bg: 'primary.hover',
        }}
        loading={isPending}
      >
        {t('save')}
      </Button>
    </form>
  );
};

export default RegisterForm;
